// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ContentItemType, ShareMedium, ShareEvent } from "../schema";

export function serialize_ShareEvent(obj: ShareEvent): string {
  const serialized = ((value: { contentItemType: ContentItemType; id: string; shareMedium: ShareMedium }): unknown => {
    return {
      contentItemType: ((value: "UNKNOWN" | "SUMMARY" | "CATEGORY" | "CHANNEL" | "LGXP" | "ACTIONABLE" | "MYLIST" | "CUSTOMPAGE" | "MIAB" | "EXPERT_VIDEO" | "CUSTOMER_STORY"): unknown => {
        return value;
      })(value["contentItemType"]),
      id: ((value: string): unknown => {
        return value;
      })(value["id"]),
      shareMedium: ((value: "COPY_LINK" | "FACEBOOK" | "FACEBOOK_WORKSPACE" | "TWITTER" | "LINKEDIN" | "EMAIL" | "IFRAME" | "SCORM" | "TEAMS" | "WECHAT" | "XING"): unknown => {
        return value;
      })(value["shareMedium"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ShareEvent(str: string): ParserResult<ShareEvent> {
  return ((
    value: unknown,
  ): ParserResult<{
    contentItemType: ContentItemType;
    id: string;
    shareMedium: ShareMedium;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ShareEvent]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ShareEvent]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "contentItemType")) {
      return { success: false, reason: `[#/components/schemas/ShareEvent/contentItemType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentItemType'.` };
    }
    const parsed_contentItemType = ((): ParserResult<ContentItemType> => {
      return ((value: unknown): ParserResult<ContentItemType> => {
        return ((value: unknown): ParserResult<"UNKNOWN" | "SUMMARY" | "CATEGORY" | "CHANNEL" | "LGXP" | "ACTIONABLE" | "MYLIST" | "CUSTOMPAGE" | "MIAB" | "EXPERT_VIDEO" | "CUSTOMER_STORY"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/ContentItemType]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "UNKNOWN":
              return { success: true, value: "UNKNOWN" };
            case "SUMMARY":
              return { success: true, value: "SUMMARY" };
            case "CATEGORY":
              return { success: true, value: "CATEGORY" };
            case "CHANNEL":
              return { success: true, value: "CHANNEL" };
            case "LGXP":
              return { success: true, value: "LGXP" };
            case "ACTIONABLE":
              return { success: true, value: "ACTIONABLE" };
            case "MYLIST":
              return { success: true, value: "MYLIST" };
            case "CUSTOMPAGE":
              return { success: true, value: "CUSTOMPAGE" };
            case "MIAB":
              return { success: true, value: "MIAB" };
            case "EXPERT_VIDEO":
              return { success: true, value: "EXPERT_VIDEO" };
            case "CUSTOMER_STORY":
              return { success: true, value: "CUSTOMER_STORY" };
            default:
              return {
                success: false,
                reason: `[#/components/schemas/ContentItemType]: '${value}' expected to be enum, one of 'UNKNOWN, SUMMARY, CATEGORY, CHANNEL, LGXP, ACTIONABLE, MYLIST, CUSTOMPAGE, MIAB, EXPERT_VIDEO, CUSTOMER_STORY'.`,
              };
          }
        })(value);
      })(value["contentItemType"]);
    })();
    if (!parsed_contentItemType.success) {
      return { success: false, reason: parsed_contentItemType.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/ShareEvent/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ShareEvent/id]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    if (!hasProp(value, "shareMedium")) {
      return { success: false, reason: `[#/components/schemas/ShareEvent/shareMedium]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'shareMedium'.` };
    }
    const parsed_shareMedium = ((): ParserResult<ShareMedium> => {
      return ((value: unknown): ParserResult<ShareMedium> => {
        return ((value: unknown): ParserResult<"COPY_LINK" | "FACEBOOK" | "FACEBOOK_WORKSPACE" | "TWITTER" | "LINKEDIN" | "EMAIL" | "IFRAME" | "SCORM" | "TEAMS" | "WECHAT" | "XING"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/ShareMedium]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "COPY_LINK":
              return { success: true, value: "COPY_LINK" };
            case "FACEBOOK":
              return { success: true, value: "FACEBOOK" };
            case "FACEBOOK_WORKSPACE":
              return { success: true, value: "FACEBOOK_WORKSPACE" };
            case "TWITTER":
              return { success: true, value: "TWITTER" };
            case "LINKEDIN":
              return { success: true, value: "LINKEDIN" };
            case "EMAIL":
              return { success: true, value: "EMAIL" };
            case "IFRAME":
              return { success: true, value: "IFRAME" };
            case "SCORM":
              return { success: true, value: "SCORM" };
            case "TEAMS":
              return { success: true, value: "TEAMS" };
            case "WECHAT":
              return { success: true, value: "WECHAT" };
            case "XING":
              return { success: true, value: "XING" };
            default:
              return { success: false, reason: `[#/components/schemas/ShareMedium]: '${value}' expected to be enum, one of 'COPY_LINK, FACEBOOK, FACEBOOK_WORKSPACE, TWITTER, LINKEDIN, EMAIL, IFRAME, SCORM, TEAMS, WECHAT, XING'.` };
          }
        })(value);
      })(value["shareMedium"]);
    })();
    if (!parsed_shareMedium.success) {
      return { success: false, reason: parsed_shareMedium.reason };
    }
    return { success: true, value: { contentItemType: parsed_contentItemType.value, id: parsed_id.value, shareMedium: parsed_shareMedium.value } };
  })(parseJsonWithNumbersAsBigint(str));
}
